import StreetAddressContainer from './StreetAddressContainer';

export default StreetAddressContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/StreetAddress/index.js